import { AiOutlineFile, AiOutlineFileImage } from "react-icons/ai";

import { AiOutlineFilePdf } from "react-icons/ai";

export const DOCUMENT_ICON = {
    pdf: <AiOutlineFilePdf />,
    png: <AiOutlineFileImage />,
    jpg: <AiOutlineFileImage />,
    jpeg: <AiOutlineFileImage />,
    file: <AiOutlineFile />,
};

export const renderFileIcons = (fileName) => {
    let extension = fileName
        .slice(fileName.lastIndexOf(".") + 1)
        .toLocaleLowerCase();
    let icons = DOCUMENT_ICON[extension];
    return icons ? icons : DOCUMENT_ICON["file"];
};
